export default __webpack_public_path__ + "school2.25abf69.png";